import styled from '@emotion/styled';

export type StyledDivProps = React.HTMLAttributes<HTMLDivElement>;

const StyledDivMobile = styled.div<StyledDivProps>({
  'alignItems': 'center',
  'display': 'flex',
  'marginBottom': 40,
  'overflowX': 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
});

export default StyledDivMobile;
